.exchange-indicator {
  display: flex;
  align-items: center;
  height: 24px;
  background: var(--exchange-indicator-color);
  color: var(--white);
}
